<template>
    <div v-if="specialNeedsEnabled" class="filter-container" @click="handleClose">
        <button-filter-dropdown @click="open" :isExpanded="modalOpen">
            <template v-slot:buttonFilterContent>
                <span v-if="!selectedSpecialNeeds.length">
                    {{specialNeedsHeader}}
                </span>
                <span v-else :class="{'has-multiple' : selectedSpecialNeeds.length > 1}">
                    <template v-for="(selected, index) in selectedSpecialNeeds">
                        {{index < selectedSpecialNeeds.length - 1 ? selected + ',' : selected}}
                    </template>
                </span>
            </template>
        </button-filter-dropdown>
        <modal-filter-dropdown :items="specialNeeds" v-show="modalOpen">
            <template #modalFilterType="item">
                <div>
                    <label>
                        <input :checked="isChecked(item.props.Key)" @change="check($event)" :value="item.props.Key" type="checkbox" name="filterTypeCheckbox" />
                        <span>
                            {{item.props.Value}}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" width="18" height="15" aria-hidden="true" focusable="false">
                                <path fill="#000" d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"></path>
                            </svg>
                        </span>
                    </label>
                </div>
            </template>
        </modal-filter-dropdown>
    </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';
import merlinFilterDropdown from '../../shared/merlinFilterDropdown.vue';
import { mapState, mapGetters } from 'vuex';
import buttonFilterDropdown from '../../shared/buttonFilterDropdown.vue';
import modalFilterDropdown from '../../shared/modalFilterDropdown.vue';

export default {
    components: {
        buttonFilterDropdown,
        modalFilterDropdown
    },
    extends: merlinFilterDropdown,
    methods: {
        check(e) {
            if (!e.target.checked) {
                this.$store.commit('specialNeeds/toggleSpecialNeedsIds', e.target.value);
                this.$store.dispatch('filterAttractions');
            } else {
                this.$store.commit('specialNeeds/toggleSpecialNeedsIds', e.target.value);
                this.$store.dispatch('filterAttractions');
            }
        },
        isChecked(key){
            return this.specialNeedsIds.includes(key);
        },
    },
    computed: {
        ...mapState('specialNeeds', ['specialNeedsHeader', 'specialNeeds', 'specialNeedsIds', 'specialNeedsEnabled']),
        selectedSpecialNeeds() {
            return this.specialNeeds.filter((need) => {
                if (this.specialNeedsIds.includes(need.Key)) {
                    return need.Value;
                }
            }).map((filtered) => {
                return filtered.Value;
            });
        }
    }
};

</script>